<template>
  <div class="sms-container">
    <div class="sms-header">
      <div class="sms-header-box">
        <div class="sms-global-menu">
          <img class="hna-logo" src="../../assets/fd_hna_logo.png" alt=""/>

          <div class="sms-system-name">数字化安全管理平台</div>
          <div class="sms-menus">
            <router-link :to="{name:'safeMap'}">安全地图</router-link>
            <router-link :to="{name:'safeResult'}">安全结果</router-link>
            <router-link :to="{name:'coreRisk'}">核心风险</router-link>
            <router-link :to="{name:'operationOverview'}">运行概况</router-link>
            <router-link :to="{name:'keyProcess'}">关键流程</router-link>
            <router-link :to="{name:'kpiMonitoring'}">KPI告警监控</router-link>
            <router-link :to="{name:'safeExamine'}">安全考核</router-link>
          </div>
        </div>
        <div class="sms-global-ctrl">
          <div class="sms-company el-select-wrapper">
            <el-select v-model="selectCompany" placeholder="请选择" @change="onCompanyChange">
              <el-option v-for="item in companyOptions" :key="item.code"
                         :label="item.shortName ? item.shortName : item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="sms-user">
            <i class="icon-user el-icon-user"></i>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">{{ user.fullName }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="!enableSso" command="logoutDev">注销(本地调试)</el-dropdown-item>
                <el-dropdown-item v-if="enableSso" command="logout">注销</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!--          <div class="sms-setting" @click="setting">-->
          <!--            <i class="el-icon-setting"></i>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div class="sms-content">
      <!--登录跳转页面可以放行-->
      <router-view v-if="isCasLogin || company" :company="company" :companyOptions="companyOptions"
                   :username="user.username"/>
    </div>
  </div>
</template>

<script>
import {getRequest, postRequest} from "../../utils/request";
import {clearStorage, getStore, setStore} from "../../utils/storage"
import Watermark from "../../utils/watermark";
import {postRequestSms} from "../../utils/requestForSms";

const NO_LOGIN = "未登录"
export default {
  data() {
    return {
      company: null,
      selectCompany: null,
      companyOptions: [],
      user: {
        fullName: NO_LOGIN,
        username: null
      },
      enableSso: process.env.enableSso,
      isCasLogin: false,
      companyOrder: ["JTAWH", "HU", "JD", "GS", "8L", "PN", "9H", "FU", "UQ", "Y8", "GT"]
    }
  },
  mounted() {
    //如果是登录验证页面，不需要做什么
    if (this.$route.path.includes("sso/sms-repo-auth") || this.$route.path.includes("sso/sms-auth")) {
      this.isCasLogin = true;
      return
    }
    //如果不是最终访问页面，不需要做什么
    let casReferer = getStore("casReferer");
    if (casReferer) {
      clearStorage("casReferer");
      location.href = casReferer;
      return;
    }

    this.currentUser();
  },
  watch: {},
  methods: {
    handleCommand(command) {
      switch (command) {
        case "logoutDev":
          this.logoutDev();
          break;
        case "logout":
          this.logout();
          break
      }
    },
    logoutDev() {
      getRequest("/sys/dev/logout")
        .then(res => {
          clearStorage("user");
          location.href = "/";
        })
    },
    logout() {
      getRequest("/sys/logout")
        .then(res => {
          clearStorage("user");
          location.href = res.data
        })
    },
    currentUser() {
      getRequest("/sys/current-user")
        .then(res => {
          this.user = res.data;
          //设置水印
          Watermark.init(this.user.empId)
          //保存用户
          setStore("user", this.user);
        })
        .then(res => {
          //加载航司
          this.getCompanyOptions();
        })
    },
    getCompanyOptions() {
      //从两个系统获取航司
      Promise.all([getRequest("/user/company/options"),
        postRequestSms("/query.do", {
          //此处调用免登录请求可避免初次访问首页时，刚验证完安全绩效登陆，又立刻开始Sms登录验证，会导致页面闪烁次数过多，体验不好
          nologin: "Y",
          username: this.user.username,
          method: "getPermissions",
          permissionSets: "MANAGE_KPI_LIBRARY",
        })])
        .then(res => {
          let repoRes = res[0];
          this.companyOptions = repoRes.data;

          let smsRes = res[1];
          let unionUnits = smsRes.data.unionUnits;
          unionUnits.forEach(unit => {
            unit.srcId = unit.id;
            unit.shortName = unit.unitReferred;

            if (!this.companyOptions.some(item => item.srcId === unit.id)) {
              this.companyOptions.push(unit);
            }
          })

          this.orderForCompany();

          if (this.$route.query.company) {
            //如果已指定航司，则设置为指定航司
            this.selectCompany = this.$route.query.company;
            this.onCompanyChange();
          } else {
            //获取航司选项后，加载当前航司
            getRequest("/user/company/current/get")
              .then(res => {
                //设置当前航司
                this.selectCompany = res.data;
                this.company = res.data;
              })
          }
        })
    },
    setting() {
      this.$router.push("/admin/setting")
    },
    /**
     * 选择航司
     */
    onCompanyChange() {
      //航司变化后，修改当前航司，并重新设置
      postRequest("/user/company/current/set", {
        code: this.selectCompany
      }).then(res => {
        this.company = res.data;
      })
    },
    /**
     * 航司排序
     */
    orderForCompany() {
      //挑出在排序表中的航司，进行排序后，放在前面，其他航司顺序不变，放在后面
      let normalCompanyOptions = this.companyOptions.filter(item => this.companyOrder.some(code => code === item.code));
      let noNormalCompanyOptions = this.companyOptions.filter(item => !this.companyOrder.some(code => code === item.code));
      normalCompanyOptions.sort((a, b) => {
        let aOrder = this.companyOrder.findIndex(code => code === a.code);
        let bOrder = this.companyOrder.findIndex(code => code === b.code);
        return aOrder - bOrder;
      })
      this.companyOptions.splice(0);
      normalCompanyOptions.forEach(item => this.companyOptions.push(item));
      noNormalCompanyOptions.forEach(item => this.companyOptions.push(item));
    },
  }
}
</script>

<style lang="less">
.sms-container {
  background-color: #f0f1f7;
}

.risk-level-color-red {
  color: #ff0000;
}

.risk-level-color-orange {
  color: #ff9100ff;
}

.risk-level-color-yellow {
  color: #f7ca6a;
}

.risk-level-color-blue {
  color: #137bfe;
}

.risk-level-color-green {
  color: #49d58d;
}

.risk-level-bg-color-red {
  background-color: #ff0000;
}

.risk-level-bg-color-orange {
  background-color: #ff9100ff;
}

.risk-level-bg-color-yellow {
  background-color: #f7ca6a;
}

.risk-level-bg-color-blue {
  background-color: #137bfe;
}

.risk-level-bg-color-green {
  background-color: #49d58d;
}

.sms-header {
  background: #36425d;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  height: 70px;
}

.sms-header-box {
  display: flex;
  /*header总高度70，body嵌入18，故实际高度52*/
  height: 52px;
  padding: 0 17px;
}

.sms-global-menu {
  display: flex;
  align-items: center;
}

.hna-logo {
  height: 33px;
  margin-top: 2px;
}

.sms-system-name {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  margin-left: 20px;
}

.sms-menus {
  margin-left: 30px;
  font-size: 13px;
  font-weight: bold;
}

.sms-menus a {
  color: #75777c;
  text-decoration: none;
}

//覆盖激活样式
a.router-link-active {
  color: #fff !important;
  text-decoration: none !important;
}

.sms-menus a:not(:first-child) {
  margin-left: 16px;
}

.sms-menus a:hover {
  color: #fff;
  text-decoration: none;
}

.sms-global-ctrl {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .sms-company {
    width: 110px;
  }

  .sms-setting {
    margin-left: 10px;

    i {
      font-size: 21px;
      color: #a0a1a3;
    }

    &:hover {
      cursor: pointer;

      i {
        color: #fff;
      }
    }
  }
}

/*公共表单组件样式 - 开始*/
//下拉选样式
.el-select-wrapper {
  .el-select {
    width: 100%;
  }

  .el-input__inner {
    height: 28px;
    line-height: 28px;
    color: #7a7a7a;
    font-size: 12px;
    padding-left: 9px;
  }

  .el-input__icon {
    line-height: 28px;
  }

  .el-input__suffix {
    text-align: left;
  }
}

.el-input-wrapper {
  .el-input__inner {
    height: 28px;
    line-height: 28px;
    color: #7a7a7a;
    font-size: 12px;
    padding-left: 9px;
  }

  .el-textarea__inner {
    color: #7a7a7a;
    font-size: 12px;
    padding-left: 9px;
    //覆盖默认字体
    font-family: auto;
  }

  .el-input__icon {
    line-height: 28px;
  }
}

//日期选择器样式
.el-date-picker-wrapper {
  .el-date-editor {
  }

  .el-input__inner {
    height: 30px;
    line-height: 30px;
  }

  .el-input__icon {
    line-height: 30px;
  }
}

/*公共表单组件样式 - 结束*/

.sms-user {
  margin-left: 15px;
  display: flex;
  align-items: center;
  color: #a0a1a3;

  .icon-user {
    font-size: 18px;
  }

  .el-dropdown {
    margin-left: 5px;
  }

  .el-dropdown-link {
    font-size: 10px;
    color: #a0a1a3;
  }
}

.sms-content {
  margin: 0 auto;
  width: 98%;
  top: -18px;
  position: relative;
}

//核心风险 - 关联kpi的popper定制样式
.popper-core-risk-kpi {
  //这里优先级低于.el-popper，所以增加!important
  background-color: #34405c !important;
  border-radius: 10px !important;

  .popper-title {
    color: #fff;
    margin-bottom: 10px;
  }

  .ac-data-box {
    display: flex;
    align-items: center;
    color: #fff;
    justify-content: space-between;

    &:not(:last-child) {
      margin-bottom: 5px;
    }

    .ac-type {

    }

    .ac-value {

    }
  }
}

//通用过滤器组件样式
.filter-list {
  display: flex;
  margin: 5px 0;

  .filter-item {
    display: flex;
    align-items: center;

    .item-label {
      font-size: 14px;
    }

    .item-component {
      margin-left: 10px;
    }
  }
}

//溢出显示省略号
.overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

//默认风险等级颜色
.default-bg-color {
  background-color: #f0f1f8;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/Layout.vue